import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {enableProdMode} from "@angular/core";
import {environment} from "./environments/environment";
import {BusinessModule} from "./business/business.module";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(BusinessModule);
